module.exports = __webpack_public_path__ + "img/Ayesha Malik, Co-Director SIF, Schulich Finance Association.bb7297ea.webp";